import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'vds-menu-mobile',
  styleUrl: 'vds-menu-mobile.scss',
  shadow: true,
})
export class VdsMenuMobile {

  @Element() el!: HTMLElement;

  /**
   * The current status of the menu
   */
  @Prop({ mutable: true, reflect: true }) open: boolean = false;

  render() {
    const { open } = this;

    return (
      <Host>
        <div class="block md:hidden w-full top-0">
          <div class="menu-top bg-white px-[20px] py-[15px] border-b-2 border-yellow">
            <div class="relative flex">
              <div class="flex flex-wrap items-center">
                <slot name="logo"></slot>
              </div>
              <div class="flex flex-wrap items-center ml-auto">
                <button class="submenu-button" onClick={() => (this.open = !this.open) }>
                  { this.menuToggleSVG(open) }
                </button>
              </div>
            </div>
          </div>
          <div class={{
            "submenu-container absolute left-0 right-0 transition-[height] duration-[200ms] overflow-hidden": true}}
            style={{ 'height': open ? 'calc(100vh - 68px)' : '0' }}>

            <div class="flex flex-col h-full">
              <div class="overflow-auto bg-white flex-1 px-[20px] pb-[10px]">
                <div class="flex flex-wrap">
                  <ul class="w-full list-none">
                    <slot name="nav-item"></slot>
                  </ul>
                  <ul class="mt-[25px] flex flex-wrap flex-col py-[11px]">
                    <slot name="nav-item-meta"></slot>
                  </ul>
                </div>
              </div>
              <div class="bg-white px-[20px] pt-[10px] pb-[25px] border-t border-grey-lighter">
                <div class="flex flex-wrap justify-between">
                  <slot name="social-icon"></slot>
                </div>
              </div>
            </div>

          </div>
        </div>
      </Host>
    );
  }

  private menuToggleSVG(open: boolean): string {
    if (open) {
      return (
        <svg viewBox="51 51 26 26" width="19">
          <path d="M76 52 64 64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
          <path d="M76 76 52 52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
          <path d="M60 68 52 76" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
        </svg>
      )
    }
    else {
      return (
        <svg viewBox="51 54 26 20" width="19" height="15">
          <path d="M76,73H52m0-18H76m0,9H52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
        </svg>
      )
    }
  }

}
